export default "__VITE_ASSET__CEsEopTa__"